
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
  name: "SortHeader",
  components: {},
})
export default class SortHeader extends Vue {
  @Prop({ type: Boolean, default: true }) showSearch?: any;
  @Prop({ type: Boolean, default: true }) isSearch?: any;
  @Prop({ type: String }) title!: any;
  @Prop({ type: String, default: null }) preSearch: any;
  @Prop({ type: Number, default: null }) total: any;
  @Prop({ type: String, default: "" }) placeholder: any;
  searchValue: any = "";
  active: number = 0;
  sortList = [
    {
      value: "release_date",
      label: "最新",
    },
    {
      value: "gmt_create",
      label: "时间",
    },
    {
      value: "page_view",
      label: "热度",
    },
  ];
  mounted() {
    if (this.preSearch) {
      this.searchValue = this.preSearch;
    }
  }
  search() {
    this.$emit("search", { title: this.searchValue });
  }
  click(index: number) {
    this.active = index;
    let options: any = {
      sort: this.sortList[index].value,
    };
    // switch(index) {
    //   case 0: options.time = new Date();break;
    //   case 1: options.time = new Date();break;
    //   case 2: options.time = new Date();break;
    //   default: break;
    // }
    this.$emit("search", options);
  }
}
